"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _helpers = require("../../helpers.js");
var _prettify = require("../../prettify.js");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
var _standalone = _interopRequireDefault(require("prettier/standalone"));
var _parserBabylon = _interopRequireDefault(require("prettier/parser-babylon"));
var _reactSimpleCodeEditor = _interopRequireDefault(require("react-simple-code-editor"));
var _prismCore = require("prismjs/components/prism-core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
if (process.env.NODE_ENV !== 'test') {
  // eslint-disable-next-line global-require
  require('prismjs/components/prism-javascript');
}
var Fortress = window.cccisd.fortress;
var prettify = function prettify(code) {
  return _standalone["default"].format(code, {
    parser: 'babylon',
    plugins: [_parserBabylon["default"]],
    singleQuote: true,
    arrowParens: 'avoid',
    tabWidth: 4
  });
};
var isCorrectJs = function isCorrectJs(code) {
  try {
    prettify(code);
  } catch (e) {
    return false;
  }
  return true;
};
var prettifyJs = function prettifyJs(code) {
  return prettify(code);
};
var _default = exports["default"] = {
  handle: 'wysiwyg',
  label: 'WYSIWYG',
  initialSettings: {
    fields: [],
    pattern: '',
    totalPattern: ''
  },
  getAdditionalFields: function getAdditionalFields(_ref) {
    var settings = _ref.settings;
    return settings.fields.map(function (field) {
      return field.path;
    });
  },
  isCustomTotal: function isCustomTotal(_ref2) {
    var settings = _ref2.settings;
    return Boolean(settings.totalPattern);
  },
  SettingsComponent: function SettingsComponent(_ref3) {
    var values = _ref3.values,
      columnSettings = _ref3.columnSettings;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
      name: "fields",
      render: function render(arrayHelpers) {
        return /*#__PURE__*/_react["default"].createElement("div", null, values.fields.map(function (item, index) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: index
          }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "fields.".concat(index, ".path"),
            render: function render(_ref4) {
              var field = _ref4.field,
                form = _ref4.form;
              return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
                field: field,
                form: form,
                label: "Path $".concat(index + 1),
                description: /*#__PURE__*/_react["default"].createElement("span", null, "For example, ", /*#__PURE__*/_react["default"].createElement("b", null, "pawn.pawnId"), " or ", /*#__PURE__*/_react["default"].createElement("b", null, "pawn { pawnId }"))
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].block
              }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("textarea", _extends({
                className: "form-control"
              }, field, {
                style: {
                  height: '5em'
                }
              }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
                className: "btn btn-danger btn-xs",
                type: "button",
                onClick: function onClick() {
                  return arrayHelpers.remove(index);
                }
              }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)))));
            }
          }));
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-default btn-sm",
          type: "button",
          onClick: function onClick() {
            return arrayHelpers.insert(values.fields.length, {
              id: (0, _helpers.generateNewId)(values.fields),
              path: ''
            });
          }
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
          spaceRight: true
        }), "Add additional data")));
      }
    }), !values.useCustomCode && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "pattern",
      component: _cccisdFormik.CccisdWysiwyg,
      type: "input",
      label: "Pattern",
      description: /*#__PURE__*/_react["default"].createElement("span", null, "Use $0 for column value. Additional data would be $1, $2, etc.", /*#__PURE__*/_react["default"].createElement("br", null), "For example, ", /*#__PURE__*/_react["default"].createElement("b", null, "$0 ($1)"))
    }), columnSettings.includeInTotal && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "totalPattern",
      component: _cccisdFormik.CccisdWysiwyg,
      type: "input",
      label: "Custom total pattern",
      description: /*#__PURE__*/_react["default"].createElement("span", null, "Use ${path.to.graphql.data} to get data from graphql result.", /*#__PURE__*/_react["default"].createElement("br", null), "For example, ", /*#__PURE__*/_react["default"].createElement("b", null, "Total: ", "${studentSummary.total}"))
    })), Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "useCustomCode",
      render: function render(_ref5) {
        var field = _ref5.field;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "checkbox"
        }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
          type: "checkbox",
          name: field.name,
          onChange: field.onChange,
          checked: !!field.value
        }), ' ', "use custom JS code"));
      }
    }), values.useCustomCode && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "customCode",
      render: function render(_ref6) {
        var field = _ref6.field,
          form = _ref6.form;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].codeEditorTextarea
        }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
          field: field,
          form: form,
          label: "Custom JS code",
          description: /*#__PURE__*/_react["default"].createElement("div", null, "It should be a function which returns an HTML string. For example:", /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].code,
            style: {
              marginTop: '0.3rem'
            }
          }, "({ settings, value, row, rows, inTotal, extraData, columnRenderParams }) => {\n    return `<b>${Math.round(row['fields.total'] / 100)}%</b>`;\n};"))
        }, /*#__PURE__*/_react["default"].createElement(_reactSimpleCodeEditor["default"], {
          highlight: function highlight(code) {
            return (0, _prismCore.highlight)(code, _prismCore.languages.js);
          },
          onValueChange: function onValueChange(value) {
            return form.setFieldValue(field.name, value);
          },
          padding: "1em",
          style: {
            background: '#fff',
            border: '1px solid #ccc',
            borderRadius: '0.5em',
            caretColor: '#333',
            fontFamily: "Menlo, Monaco, Consolas, 'Courier New', monospace",
            fontSize: '14px',
            minHeight: '200px'
          },
          tabSize: 4,
          value: field.value || ''
        })));
      }
    }));
  },
  validateSettings: function validateSettings(values) {
    var errors = {};
    values.fields.forEach(function (value, index) {
      if (!value.path) {
        errors["fields.".concat(index, ".path")] = 'The field is required';
      } else if (!(0, _prettify.isCorrectQuery)(value.path)) {
        errors["fields.".concat(index, ".path")] = 'Wrong syntax or getting more than one field';
      }
    });
    if (values.useCustomCode) {
      if (!values.customCode) {
        errors.customCode = 'You have to provide custom code';
      } else if (!isCorrectJs(values.customCode)) {
        errors.customCode = 'Wrong JS syntax';
      }
    } else if (!values.pattern) {
      errors.pattern = 'Pattern is required';
    }
    return errors;
  },
  prepareValues: function prepareValues(values) {
    return _objectSpread(_objectSpread({}, values), {}, {
      fields: values.fields.map(function (field) {
        return _objectSpread(_objectSpread({}, field), {}, {
          path: (0, _prettify.prettifyQuery)(field.path)
        });
      })
    }, values.useCustomCode && values.customCode ? {
      customCode: prettifyJs(values.customCode)
    } : {});
  },
  getColumnSettings: function getColumnSettings(settings) {
    return {
      render: function render(_ref7) {
        var value = _ref7.value,
          row = _ref7.row,
          rows = _ref7.rows,
          inTotal = _ref7.inTotal,
          extraData = _ref7.extraData,
          columnRenderParams = _ref7.columnRenderParams;
        var toString = function toString(item) {
          return item || item === 0 ? item : '';
        };
        var result = '';
        if (settings.useCustomCode) {
          try {
            // remove last semicolon if it exists
            var justFunction = settings.customCode.replace(/;\s*$/, '');

            // eslint-disable-next-line no-eval
            eval("result = (".concat(justFunction, ")({ settings, value, row, rows, inTotal, extraData, columnRenderParams });"));
          } catch (e) {
            console.error('Something wrong with the custom code');
            result = 'Error';
          }
        } else if (inTotal && settings.totalPattern) {
          result = settings.totalPattern.replace(/(\$\{)([\w.]+)(\})/g, function (str, prefix, path) {
            return (0, _get2["default"])(extraData, path, '');
          });
        } else {
          // grabbing values from row
          result = settings.pattern.replace(new RegExp("\\$0", 'g'), toString(value));
          settings.fields.forEach(function (field, index) {
            var search = new RegExp("\\$".concat(index + 1), 'g');
            result = result.replace(search, toString(row[(0, _helpers.getPathFromQuery)(field.path)]));
          });
        }
        return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: result
        });
      }
    };
  }
};